import { render, staticRenderFns } from "./n-spinner.vue?vue&type=template&id=91b5e7f6&"
import script from "./n-spinner.vue?vue&type=script&lang=ts&"
export * from "./n-spinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports